import { render, staticRenderFns } from "./FolderDeArchive.vue?vue&type=template&id=53b76d2c"
import script from "./FolderDeArchive.vue?vue&type=script&lang=js"
export * from "./FolderDeArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports